/**
 * What a save from before the tally existed reads as: all twelve out. D-186 —
 * a cold boot shows the beat at full shape rather than at a debug one. Lives
 * here, not in `shell/save.ts`, so the room that draws the number does not
 * import the shell.
 */
export const DEFAULT_OUT = 12;

/** The stock count on Kestner's page before Beat 10's culvert run. */
export const TALLY_STOCK = 214;

/**
 * The office's only arithmetic. `out = 0` crosses out 214 and writes 214, on
 * purpose (D-186). Red-watched: with `written` hardcoded to 202, both tally
 * specs in `beat-11-office.spec.ts` fail (the saved 5 and the URL 0).
 */
export function tallyForOut(out: number): { readonly crossed: number; readonly written: number } {
  return { crossed: TALLY_STOCK, written: TALLY_STOCK - out };
}
